var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLiquid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_355_4714)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1,
    width: 48,
    height: 48,
    rx: 10,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 1.5,
    width: 47,
    height: 47,
    rx: 9.5,
    stroke: "#EAECF0",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4503 30.2999C29.7703 30.2999 28.2202 29.5099 27.2102 28.1199C26.9702 27.7899 27.0402 27.3199 27.3702 27.0699C27.7002 26.8199 28.1703 26.8999 28.4203 27.2299C29.1503 28.2199 30.2503 28.7899 31.4503 28.7899C33.5403 28.7899 35.2502 27.0899 35.2502 24.9899C35.2502 22.8899 33.5503 21.1899 31.4503 21.1899C30.0303 21.1899 28.6902 21.9499 27.9602 23.1599L25.3102 27.5699C24.3102 29.2399 22.4803 30.27 20.5403 30.27C17.6203 30.27 15.2402 27.8899 15.2402 24.9699C15.2402 22.0499 17.6203 19.6699 20.5403 19.6699C22.2203 19.6699 23.7702 20.4599 24.7802 21.8499C25.0202 22.1799 24.9502 22.65 24.6202 22.9C24.2802 23.14 23.8203 23.0699 23.5703 22.7399C22.8403 21.7499 21.7403 21.1799 20.5403 21.1799C18.4503 21.1799 16.7402 22.8799 16.7402 24.9799C16.7402 27.0799 18.4403 28.78 20.5403 28.78C21.9603 28.78 23.3002 28.0199 24.0302 26.8099L26.6802 22.4C27.6802 20.73 29.5103 19.7 31.4503 19.7C34.3703 19.7 36.7502 22.0799 36.7502 24.9999C36.7502 27.9199 34.3703 30.2999 31.4503 30.2999Z",
    fill: "#292D32"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_355_4714",
    x: 0,
    y: 0,
    width: 52,
    height: 52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_355_4714"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_355_4714",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiquid);
export default __webpack_public_path__ + "static/media/liquid.3af2907f036e0599e34616cc726a3413.svg";
export { ForwardRef as ReactComponent };